/**
 * Created by vblanco on 28/08/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    //Aquí defino el estado de edicion details
    /* @ngInject */
    function stateConfig($stateProvider) {
        //ESTADO ABSTRACTO

        $stateProvider.state('ejemplarDetails', {
            parent: 'edicionDetails',

            url: '/ejemplar/:ejemplarId',
            data: {
                pageTitle: 'ejemplarDetails.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/ejemplar/ejemplar.details.html',
                    controller: 'EjemplarDetailsController',
                    controllerAs: 'ctrlDetails'
                }
            },
            // Listar
            resolve: {
                /* @ngInject */
                ejemplar: function (Ejemplar, $stateParams) {
                    return Ejemplar.get({id: $stateParams.ejemplarId}).$promise.then(function (data) {
                        return data;
                    });
                }
            }
        });
    }
})();

